import { CSS, styled } from "@givenwell/stitches";
import { colors } from "@givenwell/theme";
import { Checkbox as BaseCheckbox } from "radix-ui";
import { ForwardedRef, forwardRef, useContext } from "react";
import { FieldContext } from "./Field";

const check = (
  <svg
    width="12"
    height="10"
    viewBox="0 0 12 10"
    style={{
      fill: "none",
      strokeWidth: 2,
      stroke: "currentColor",
      strokeDasharray: 16,
    }}
  >
    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
  </svg>
);

const dash = (
  <svg
    viewBox="0 0 24 24"
    style={{
      stroke: "currentColor",
      strokeWidth: 3,
    }}
  >
    <line x1="21" x2="3" y1="12" y2="12"></line>
  </svg>
);

export type CheckboxProps = Omit<BaseCheckbox.CheckboxProps, "onCheckedChange"> & {
  css?: CSS;
  invalid?: boolean;
  onCheckedChange?: (checked: boolean) => void;
};

export const Checkbox = forwardRef(function Checkbox(props: CheckboxProps, ref: ForwardedRef<HTMLButtonElement>) {
  const { inputProps } = useContext(FieldContext);
  return (
    <Root {...inputProps} {...props} ref={ref}>
      <Indicator state="checked">{check}</Indicator>
      <Indicator state="indeterminate">{dash}</Indicator>
    </Root>
  );
});

const Root = styled(BaseCheckbox.Root, {
  border: "2px solid",
  borderColor: colors.outline,
  borderRadius: 2,
  display: "inline-flex",
  size: 20,
  flexShrink: 0,
  "&:hover": {
    background: colors.warmGrey,
  },

  "&[data-state=checked], &[data-state=indeterminate]": {
    borderColor: colors.navy,
    background: colors.navy,

    "&:hover": {
      borderColor: colors.navy,
      background: colors.navy,
    },
  },

  variants: {
    invalid: {
      true: {
        borderColor: colors.red500,
      },
    },
  },
});
const Indicator = styled(BaseCheckbox.Indicator, {
  color: "white",
  size: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  variants: {
    state: {
      checked: {
        "&[data-state=indeterminate]": {
          display: "none",
        },
      },
      indeterminate: {
        "&[data-state=checked]": {
          display: "none",
        },
      },
    },
  },
});
